import './OkulyonetimAddToClassModal.scss'

import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Checkbox, Collapse, Modal } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AppContext from '../../../context/AppContext'
import { useSiniflarQuery } from '../../../gql/GeneratedGraphqlTypes'
import { ReactComponent as Logo } from '../../../images/okulyonetim/add-class.svg'
import Spinner from '../../spinner/Spinner'
import { OkulyonetimAddProductToClassModalType } from './type'
const { Panel } = Collapse
const OkulyonetimAddToClassModal: React.FC<
  OkulyonetimAddProductToClassModalType & {
    selectedItems: { sinifId: number; sinifDersId: number }[]
    setSelectedItems: React.Dispatch<React.SetStateAction<{ sinifId: number; sinifDersId: number }[]>>
  }
> = ({
  image,
  title,
  price,
  quantity,
  inputValue,
  setInputValue,
  isModalOpen,
  handleOk,
  handleCancel,
  selectedItems,
  setSelectedItems,
}) => {
  const { sinif } = useContext(AppContext)
  const navigate = useNavigate()

  const [siniflar, setSiniflar] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false) // Yüklenme durumu için state
  const [isAllSelected, setIsAllSelected] = useState<boolean>(false) // Tümünü seç durumu
  const [selectedClasses, setSelectedClasses] = useState<{ [key: number]: boolean }>({})

  const { refetch } = useSiniflarQuery({
    variables: { sube_id: sinif || 0 },
    skip: true, // İlk etapta sorguyu atla
  })

  const isSinifSelected = (sinifId: number) => {
    const sinif = siniflar.find((s) => s.id === sinifId)
    return (
      sinif &&
      sinif.dersler.every((ders: any) =>
        selectedItems.some((item) => item.sinifId === sinifId && item.sinifDersId === ders.sinif_ders_id),
      )
    )
  }

  const isClassPartiallySelected = (sinifId: number) => {
    const sinif = siniflar.find((s) => s.id === sinifId)
    if (!sinif) return false

    const dersler = sinif.dersler
    const selectedCount = dersler.filter((ders: any) =>
      selectedItems.some((item) => item.sinifId === sinifId && item.sinifDersId === ders.sinif_ders_id),
    ).length

    return selectedCount > 0 && selectedCount < dersler.length
  }

  const handleSelectAll = () => {
    if (!isAllSelected) {
      const allItems = siniflar.flatMap((sinif) =>
        sinif.dersler.map((ders: any) => ({ sinifId: sinif.id, sinifDersId: ders.sinif_ders_id })),
      )
      setSelectedItems(allItems)
    } else {
      setSelectedItems([])
    }
  }

  const handleSelectSingleClass = (classId: number) => {
    const isCurrentlySelected = selectedClasses[classId] || false

    setSelectedClasses((prev) => ({
      ...prev,
      [classId]: !isCurrentlySelected,
    }))

    const selectedClass = siniflar.find((sinif) => sinif.id === classId)
    if (!selectedClass) return

    if (isCurrentlySelected) {
      const updatedItems = selectedItems.filter((item) => item.sinifId !== classId)
      setSelectedItems(updatedItems)
    } else {
      const classItems = selectedClass.dersler.map((ders: any) => ({
        sinifId: selectedClass.id,
        sinifDersId: ders.sinif_ders_id,
      }))
      setSelectedItems((prevItems) => [...prevItems, ...classItems])
    }
  }

  useEffect(() => {
    const allSelected =
      siniflar.length > 0 &&
      siniflar.every((sinif) =>
        sinif.dersler.every((ders: any) =>
          selectedItems.some((item) => item.sinifId === sinif.id && item.sinifDersId === ders.sinif_ders_id),
        ),
      )
    setIsAllSelected(allSelected)
  }, [selectedItems, siniflar])

  const handleChangeValue = (value: number | null) => {
    if (setInputValue) {
      setInputValue(value ?? 1)
    }
  }
  const handleCheckboxChange = (sinifId: number, sinifDersId: number) => {
    const exists = selectedItems.some((item) => item.sinifId === sinifId && item.sinifDersId === sinifDersId)
    if (exists) {
      // Eğer zaten seçilmişse listeden çıkarıyoruz
      setSelectedItems((prev) => prev.filter((item) => !(item.sinifId === sinifId && item.sinifDersId === sinifDersId)))
    } else {
      // Eğer seçilmemişse listemize ekledik
      setSelectedItems((prev) => [...prev, { sinifId, sinifDersId }])
    }
  }

  useEffect(() => {
    if (isModalOpen && sinif) {
      setIsLoading(true) // Yüklenme durumunu başlatıyoruz
      refetch({ sube_id: sinif })
        .then((result) => {
          const mutableSiniflar = [...(result.data?.siniflar || [])]
          setSiniflar(mutableSiniflar)
        })
        .catch((err) => {
          console.error('Sınıflar yüklenirken hata oluştu:', err)
          navigate('/')
        })
        .finally(() => {
          setIsLoading(false) // Yüklenme durumunu sonlandırıyoruz
        })
    }
  }, [isModalOpen, sinif, refetch, navigate])

  // Yüklenme durumunda spinner gösterme api sorgusu
  if (isLoading) {
    return <Spinner showSpinner={isLoading} color="red" />
  }
  const activeKeys = siniflar.map((sinif) => sinif.id.toString())
  return (
    <div>
      <Modal
        title="Eklemek İstediğiniz Kitap"
        open={isModalOpen}
        onOk={() => handleOk(selectedItems)}
        onCancel={handleCancel}
        okText={
          <>
            <Logo />
            Sınıfa Ekle
          </>
        }
        width={800}
        okButtonProps={{
          disabled: siniflar.length === 0,
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        bodyStyle={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}
        className="db-okulyonetim-add-to-class-modal"
      >
        <div className="okulyonetim-add-to-class-modal">
          <div className="okulyonetim-add-to-class-modal-info">
            <img src={image} alt="" />
            <div className="okulyonetim-add-to-class-modal-info-text">
              <div className="okulyonetim-add-to-class-modal-info-text-title">
                <div className="okulyonetim-add-to-class-modal-info-text-title">{title}</div>
                <div className="okulyonetim-add-to-class-modal-info-text-price">{price} TL</div>
              </div>
              <div className="okulyonetim-add-to-class-modal-info-text-quantity">
                <Button
                  size="large"
                  className="okulyonetim-add-btn"
                  onClick={() => handleChangeValue(Number(inputValue ?? 1) - 1)}
                  disabled={Number(inputValue ?? 1) <= 1}
                >
                  <MinusOutlined />
                </Button>
                <span className="okulyonetim-input-span">{inputValue ?? 1}</span>
                <Button
                  size="large"
                  className="okulyonetim-add-btn"
                  onClick={() => handleChangeValue(Number(inputValue ?? 1) + 1)}
                  disabled={Number(inputValue ?? 1) >= 10}
                >
                  <PlusOutlined />
                </Button>
              </div>
            </div>
          </div>
          {siniflar.length === 0 ? (
            <h3>Sınıflar Bulunamadı...</h3>
          ) : (
            <div className="select-all-checkbox-okul-yonetim">
              <p>Lütfen Sınıf Seçiniz</p>
              <div className="select-all-checkbox-btn">
                <Checkbox onChange={handleSelectAll} checked={isAllSelected}>
                  Tümünü Seç
                </Checkbox>
              </div>
            </div>
          )}

          <div className="okulyonetim-add-to-class-modal-select">
            {siniflar.length > 0 ? (
              <>
                <Collapse defaultActiveKey={activeKeys}>
                  {siniflar
                    .sort((a, b) => {
                      const getClassNumber = (sinifIsim: string) => {
                        const match = sinifIsim.match(/(\d+)\. Sınıf/)
                        return match ? parseInt(match[1], 10) : 0
                      }
                      return getClassNumber(a.isim) - getClassNumber(b.isim)
                    })
                    .map((sinif) => (
                      <Panel header={sinif.isim} key={sinif.id.toString()}>
                        <div className="okulyonetim-add-to-class-modal-select-box" key={sinif?.id}>
                          <div className="okulyonetim-add-to-class-modal-select-box-options">
                            <div className="okulyonetim-add-to-class-modal-select-box-options-select-class">
                              <Checkbox
                                onChange={() => handleSelectSingleClass(sinif?.id)}
                                checked={isSinifSelected(sinif.id)}
                                indeterminate={isClassPartiallySelected(sinif.id)}
                              >
                                Tümünü Seç
                              </Checkbox>
                            </div>
                            {sinif?.dersler.map((_ders: any) => (
                              <Checkbox
                                key={_ders.sinif_ders_id}
                                checked={selectedItems.some(
                                  (item) => item.sinifId === sinif.id && item.sinifDersId === _ders.sinif_ders_id,
                                )}
                                onChange={() => handleCheckboxChange(sinif.id, _ders.sinif_ders_id)}
                              >
                                <span>{_ders.ders_adi}</span>
                              </Checkbox>
                            ))}
                          </div>
                        </div>
                      </Panel>
                    ))}
                </Collapse>
              </>
            ) : (
              <p>sınıf bulunmamaktadır</p>
            )}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default OkulyonetimAddToClassModal
